import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initAnalytics, isAnalyticsEnabled, trackPageView } from '../lib/analytics';

/**
 * Mounts once at the top of the React tree. Initialises GA4 on first render
 * and emits a page_view on every React Router location change. Admin routes
 * are excluded to keep the public funnel data clean.
 */
export default function AnalyticsTracker() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    if (!isAnalyticsEnabled()) return;
    if (pathname.startsWith('/admin')) return;
    trackPageView(pathname + search);
  }, [pathname, search]);

  return null;
}
